import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-group"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-save me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_v_button = _resolveComponent("v-button")!

  return true
    ? (_openBlock(), _createElementBlock("fieldset", _hoisted_1, [
        (_ctx.isBillingAddress)
          ? (_openBlock(), _createElementBlock("legend", _hoisted_2, _toDisplayString(_ctx.$t('Dirección de facturación')), 1))
          : (_openBlock(), _createElementBlock("legend", _hoisted_3, _toDisplayString(_ctx.$t('Dirección de envío')), 1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_form_group_input_text, {
              value: _ctx.addressOne,
              label: _ctx.$t('Dirección 1'),
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.addressOne,
              autocomplete: "off",
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.addressOne = $event))
            }, null, 8, ["value", "label", "yup-errors-variable"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_form_group_input_text, {
              value: _ctx.addressTwo,
              label: _ctx.$t('Dirección 2'),
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.addressTwo,
              autocomplete: "off",
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.addressTwo = $event))
            }, null, 8, ["value", "label", "yup-errors-variable"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_form_group_input_text, {
              value: _ctx.postCode,
              label: _ctx.$t('Código postal'),
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.postCode,
              autocomplete: "off",
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.postCode = $event))
            }, null, 8, ["value", "label", "yup-errors-variable"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_v_form_group_input_text, {
              value: _ctx.city,
              label: _ctx.$t('Población'),
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.city,
              autocomplete: "off",
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.city = $event))
            }, null, 8, ["value", "label", "yup-errors-variable"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_form_group_select, {
              label: _ctx.$t('Provincia'),
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.state
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  class: _normalizeClass({'is-invalid': !!_ctx.errors.state}),
                  options: _ctx.countryStateOptions,
                  reduce: returnValue => returnValue.key,
                  "select-on-key-codes": [188, 13],
                  clearable: false,
                  modelValue: _ctx.state,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state) = $event))
                }, {
                  "no-options": _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                  ]),
                  _: 1
                }, 8, ["class", "options", "reduce", "modelValue"])
              ]),
              _: 1
            }, 8, ["label", "yup-errors-variable"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_v_form_group_select, {
              label: _ctx.$t('País'),
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.country
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  class: _normalizeClass({'is-invalid': !!_ctx.errors.country}),
                  options: _ctx.formsSettings.address_country_options,
                  reduce: returnValue => returnValue.key,
                  "select-on-key-codes": [188, 13],
                  clearable: false,
                  modelValue: _ctx.country,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.country) = $event))
                }, {
                  "no-options": _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                  ]),
                  _: 1
                }, 8, ["class", "options", "reduce", "modelValue"])
              ]),
              _: 1
            }, 8, ["label", "yup-errors-variable"])
          ])
        ]),
        (_ctx.can('professional.expedient.address.update'))
          ? (_openBlock(), _createBlock(_component_v_button, {
              key: 2,
              variant: "secondary",
              "aria-label": _ctx.$t('Actualizar dirección de facturación'),
              disabled: !_ctx.meta.valid || !_ctx.meta.dirty,
              "is-loading": _ctx.accepted,
              onClick: _ctx.doUpdateAddress
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                (_ctx.isBillingAddress)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Actualizar dirección de facturación')), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Actualizar dirección de envío')), 1)
                    ], 64))
              ]),
              _: 1
            }, 8, ["aria-label", "disabled", "is-loading", "onClick"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}